import { Controller } from "@hotwired/stimulus"

// 분쟁조정 확인서 이미지 업로드를 처리하는 Stimulus 컨트롤러
export default class extends Controller {
  static targets = ["imageUpload", "imagePreviewContainer", "uploadCount", "imageIdsContainer"]

  connect() {
    this.uploadedImages = [];
  }

  openImageUpload() {
    this.imageUploadTarget.click();
  }

  handleImageUpload(event) {
    const files = event.target.files;
    const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
    
    if (files.length > 0 && this.uploadedImages.length + files.length <= 10) {
      Array.from(files).forEach(file => {
        if (validTypes.includes(file.type) && file.size <= 10 * 1024 * 1024) {
          this.uploadImage(file);
        } else {
          alert('이미지 형식이 올바르지 않거나 크기가 10MB를 초과합니다.');
        }
      });
    } else if (this.uploadedImages.length + files.length > 10) {
      alert('이미지는 최대 10개까지 업로드할 수 있습니다.');
    }
  }

  uploadImage(file) {
    const formData = new FormData();
    formData.append('image', file);
    
    const tempId = 'temp_' + Math.random().toString(36).substring(2, 15);
    const previewDiv = document.createElement('div');
    previewDiv.className = 'confirmation-form__image-preview';
    previewDiv.id = `preview_${tempId}`;
    previewDiv.innerHTML = `
      <div class="confirmation-form__loading-indicator">업로드 중...</div>
    `;
    
    this.imagePreviewContainerTarget.insertBefore(previewDiv, this.imagePreviewContainerTarget.firstChild);
    
    // 서버에 이미지 업로드
    fetch('/wv/conflict_resolutions/upload_image', {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        const imageId = data.image_id;
        this.uploadedImages.push(imageId);
        
        // 이미지 정보 조회하여 썸네일 표시
        return fetch(`/wv/conflict_resolutions/image_info?image_id=${imageId}`)
          .then(response => response.json())
          .then(imageInfo => {
            if (imageInfo.success) {
              previewDiv.innerHTML = `
                <img src="${imageInfo.url}" alt="Preview">
                <button type="button" class="confirmation-form__remove-image" data-action="click->image-upload#removeImage" data-id="${imageId}">×</button>
              `;
              
              const hiddenInput = document.createElement('input');
              hiddenInput.type = 'hidden';
              hiddenInput.name = 'conflict_resolution[image_ids][]';
              hiddenInput.value = imageId;
              hiddenInput.id = `image_id_${imageId}`;
              this.imageIdsContainerTarget.appendChild(hiddenInput);
              
              this.updateUploadCount();
            } else {
              throw new Error(imageInfo.error || '이미지 정보를 불러올 수 없습니다.');
            }
          });
      } else {
        throw new Error(data.error || '이미지 업로드에 실패했습니다.');
      }
    })
    .catch(error => {
      console.error('Error:', error);
      previewDiv.innerHTML = `
        <div class="confirmation-form__upload-error">${error.message || '업로드 실패'}</div>
      `;
      
      // 3초 후 에러 메시지 삭제
      setTimeout(() => {
        previewDiv.remove();
      }, 3000);
    });
  }

  removeImage(event) {
    const imageId = event.currentTarget.dataset.id;
    const index = this.uploadedImages.indexOf(imageId);
    if (index > -1) {
      this.uploadedImages.splice(index, 1);
    }
    
    event.currentTarget.closest('.confirmation-form__image-preview').remove();
    const hiddenInput = document.getElementById(`image_id_${imageId}`);
    if (hiddenInput) hiddenInput.remove();
    this.updateUploadCount();
  }

  updateUploadCount() {
    this.uploadCountTarget.textContent = `${this.uploadedImages.length}/10`;
  }
} 